"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageHelper = void 0;
var Url_helper_1 = require("./Url.helper");
var environment_helper_1 = require("./environment.helper");
var host_helper_1 = require("./host.helper");
function getRobotsContent(props) {
    var robotsContent;
    if ((0, host_helper_1.isAPrivatePage)(props) ||
        (props.properties["sitemap.enable"] === "false" &&
            (props.properties["robots"] === "noindex" || !props.properties["robots"]))) {
        robotsContent = "noindex,nofollow";
    }
    else if (props.properties["sitemap.enable"] === "false") {
        robotsContent = props.properties["robots"];
    }
    else {
        robotsContent = "all";
    }
    return robotsContent;
}
exports.PageHelper = {
    isHCLAuthoringPage: function () {
        return (environment_helper_1.EnvironmentHelper.isClientSide() &&
            Url_helper_1.UrlHelper.isHCLAuthoringPageUrl(window.location.href));
    },
    isStaticFilePage: function () {
        return (environment_helper_1.EnvironmentHelper.isClientSide() &&
            Url_helper_1.UrlHelper.isStaticFilePageUrl(window.location.href));
    },
    isNewArchitecturePage: function () {
        return (environment_helper_1.EnvironmentHelper.isClientSide() &&
            Url_helper_1.UrlHelper.isNewArchitecturePageUrl(window.location.href));
    },
    isOldArchitecturePage: function () {
        return (environment_helper_1.EnvironmentHelper.isClientSide() &&
            Url_helper_1.UrlHelper.isOldArchitecturePageUrl(window.location.href));
    },
    getRobotsContent: getRobotsContent,
};
